import { api } from "../api";

export const getAllLockers = function (callback) {
    const user = JSON.parse(localStorage.getItem("user"));
    api.defaults.headers.authorization = `Bearer ${user.token}`;
    const URL = "/lockers";

    api
        .get(URL)
        .then((response) => {
            callback(replaceIdCaracter(response.data.data));
        })
        .catch((error) => {
            callback([]);
            console.log("Error:. getAllLockers " + error);
        });
};

export const getGrupos = function (callback) {
    const user = JSON.parse(localStorage.getItem("user"));
    api.defaults.headers.authorization = `Bearer ${user.token}`;
    const URL = "/grupos";

    api
        .get(URL)
        .then((response) => {
            callback(response.data);
        })
        .catch((error) => {
            callback([]);
            console.log("Error:. getAllLockers " + error);
        });
};

export const getAllLockersSelect = function (callback) {
    const user = JSON.parse(localStorage.getItem("user"));
    api.defaults.headers.authorization = `Bearer ${user.token}`;
    const URL = "/lockers/select";

    api
        .get(URL)
        .then((response) => {

            callback({
                listLockers: replaceIdCaracter(response.data.data.listLockers),
                listGrupos: replaceIdCaracter(response.data.data.listGrupos),
            });
        })
        .catch((error) => {
            callback([]);
            console.log("Error:. getAllLockers " + error)
        });
};

export const getLockersById = function (lockerId, callback) {
    const URL = `/lockers/${lockerId}`;

    api
        .get(URL)
        .then((response) => {
            callback(replaceIdCaracter(response.data));
        })
        .catch((error) => {
            callback([]);
            console.log("Error:. getLockersById " + error);
        });
};

export const getLockerById = function (lockerId, callback) {
    const URL = `/lockers/${lockerId}`;

    api
        .get(URL)
        .then((response) => {
            callback(response.data);
        })
        .catch((error) => {
            callback([]);
            console.log("Error:. getLockersById " + error);
        });
};

export const replaceIdCaracter = (data) => {
    const rename = ({ _id: id, ...rest }) => ({ id, ...rest });
    let dataModfified = [];

    data.map((d) => dataModfified.push(rename(d)));

    return dataModfified;
};

export const sendCmd = (lockerId, action, callback) => {
    const URL = `/socket_action/`;

    let data = {
        lockerId,
        action,
    };

    api
        .post(URL, data)
        .then((resp) => {
            callback(true);
        })
        .catch((e) => {
            console.log(e);
            callback(false);
        });
};

export const updateConfigs = (lockerId, configurations, callback) => {
    const URL = `/locker/config`;

    let data = {
        lockerId,
        configurations,
    };

    api
        .post(URL, data)
        .then((resp) => {
            callback(true);
        })
        .catch((e) => {
            console.log(e);
            callback(false);
        });
};


export const updateLocker = (lockerId, data, callback) => {
    const URL = `/lockers/${lockerId}`;

    api
        .put(URL, data)
        .then((response) => {
            callback(response.data);
        })
        .catch((error) => {
            callback([]);
            console.log("Error:. " + error);
        });
};

export const getConfigLocker = (lockerId, callback) => {
    const URL = `/locker/${lockerId}/get-config`;

    api
        .get(URL)
        .then((response) => {
            callback(response.data?.config);
        })
        .catch((error) => {
            callback([]);
            console.log("Error:. " + error);
        });
};

export const updateConfigLocker = (lockerId, config, callback) => {
    const URL = `/locker/set-config`;

    let data = {
        lockerId,
        config,
    };

    api
        .post(URL, data)
        .then((response) => {
            callback(response.data?.config);
        })
        .catch((error) => {
            callback([]);
            console.log("Error:. " + error);
        });
};

export const sendAction = (lockerId, action, event, callback) => {
    const URL = `/lockers/socket_event`;

    let data = {
        lockerId,
        action,
        event
    };

    api
        .post(URL, data)
        .then((resp) => {
            callback(true);
        })
        .catch((e) => {
            console.log(e);
            callback(false);
        });
};

export const deleteLocker = (lockerId, callback) => {
    const URL = `/lockers/delete/${lockerId}`;

    api
        .delete(URL)
        .then((response) => {
            callback(response.status);
        })
        .catch((e) => {
            console.log(e);
            callback(400);
        });
};

export const syncLocker = (lockerId, callback) => {
    const URL = `/sync/rabbit`;
   
    let data = {
        lockerId
    };

    api
        .post(URL, data)
        .then((response) => {
            callback(response.status);
        })
        .catch((e) => {
            console.log(e);
            callback(400);
        });
};

export const getFiles = (lockerId, fileType, callback) => {
    const URL = `/arquivos/` + lockerId + `/` + fileType;

    console.log("URL: " + URL)
   
    api
        .get(URL)
        .then((response) => {
            callback(response);
        })
        .catch((e) => {
            console.log(e);
            callback(400);
        });
};

export const getAllFiles = (lockerId, callback) => {
    const URL = `/files/lockers/` + lockerId;
   
    api
        .get(URL)
        .then((response) => {
            callback(response);
        })
        .catch((e) => {
            console.log(e);
            callback(400);
        });
};


export const sendFile = (lockerId, url, fileName, callback) => {
    const URL = `/download-file/locker`;

    let data = {
        lockerId,
        fileName,
        url
    }
   
    api
        .post(URL, data)
        .then((response) => {
            callback(response);
        })
        .catch((e) => {
            console.log(e);
            callback(400);
        });
};